import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { useAuth } from '@clerk/clerk-react';
import { Button } from 'primereact/button';
import {
  FileUpload,
  FileUploadHeaderTemplateOptions,
} from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Breadcrumb } from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';
import { TableAgGeneric } from '~/components/ui/tables/ag/genericTable/TableAgGeneric';
import { rows2TableData, StdTableData } from '~/lib/xlsx/xlsxFileToRows';
import { XlsxFileRow } from '~/lib/xlsx/xlsxStandardFileToRows';

export const Route = createFileRoute('/_authLayout/analytics/upload')({
  component: AnalyticsUploadComponent,
});
let worker: Worker;
function AnalyticsUploadComponent() {
  const auth = useAuth();
  const navigate = useNavigate();
  const ref = React.useRef<FileUpload>(null);
  const [rows, setRows] = useState<XlsxFileRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState<string>();
  const [tableRows, setTableRows] = useState<Record<string, string | number>[]>(
    [],
  );

  if (!auth.isSignedIn && auth.isLoaded) {
    navigate({ to: '/sign-in' });
  }

  useEffect(() => {
    if (rows.length === 0) return;
    setTableRows(rows2TableData(rows));
  }, [rows]);

  const onLoadingComplete = (rowsLoaded: XlsxFileRow[]) => {
    setRows(rowsLoaded);
    setLoading(false);
    ref.current?.clear();
    if (worker) {
      worker.terminate();
    }
  };

  const beforeUpload = (file: File) => {
    const worker = new Worker(
      new URL('../../lib/workers/xlsxLoadWorker.ts', import.meta.url),
    );
    setFileName(file.name);
    setLoading(true);
    worker.postMessage(file);
    worker.onmessage = (e) => {
      onLoadingComplete(e.data);
    };

    // if (file) {
    //   xlsxStandardFileToRows(file, onLoadingComplete);
    // }

    return false;
  };
  const handleClear = () => {
    // onLoadActiveBtn(false);
    // onClearButton(false);
  };

  const handlePostPortfolioData = async ({
    data,
  }: {
    data: StdTableData[];
  }) => {
    console.log('TODO Implement uploading excel data', data);
  };
  const emptyTemplate = () => {
    // if(loading) return <ProgressSpinner />
    return (
      <>
        <div
          className="flex align-items-center flex-column"
          style={{
            backgroundColor: 'var(--surface-b)',
            color: 'var(--bq-text-secondary, var(--text-color-secondary))',
            // margin: '-2em -1em -3em -1em'
          }}
        >
          <i
            className="pi pi-image mt-0 p-2"
            style={{
              fontSize: '3em',
            }}
          ></i>
          <span
            style={{
              color: 'var(--bq-text-secondary, var(--text-color-secondary))',
            }}
            className="text-sm pt-0 p-3"
          >
            Click or drag here XLSX file with rounds
          </span>
        </div>
      </>
    );
  };
  const headerTemplate = (options: FileUploadHeaderTemplateOptions) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;

    return (
      <div
        className={className}
        style={{
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {chooseButton}
        {uploadButton}
        {cancelButton}
      </div>
    );
  };

  return (
    <div className="flex-column flex h-full w-full">
      <Breadcrumb
        items={[
          { name: 'Analytics Dashboard', url: '/analytics' },
          { name: 'Upload' },
        ]}
      />
      <div className="grid">
        <div className="col col-3">
          <FileUpload
            ref={ref}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            name="Optimizer"
            multiple={false}
            onClear={handleClear}
            headerTemplate={headerTemplate}
            onSelect={(e) => {
              // console.log(e);
              beforeUpload(e.files[0]);
              // onLoadActiveBtn(true)
            }}
            contentClassName="bq-uploader-content"
            chooseOptions={{
              icon: 'pi pi-fw pi-plus p-button-icon-right',
              iconOnly: false,
              className:
                'custom-upload-btn p-button-success p-button-sm p-button-outlined',
            }}
            cancelOptions={{
              icon: 'none',
              iconOnly: false,
              className: 'hidden',
              label: 'clear',
            }}
            uploadOptions={{
              icon: 'none',
              iconOnly: false,
              className: 'hidden',
              label: 'clear',
            }}
            emptyTemplate={emptyTemplate}
          />
        </div>
        <div className="col col-3">
          {/*<p className="text-sm mb-3">*/}
          {/*	Select Portfolio associated with the data*/}
          {/*</p>*/}
          {/*<Select*/}
          {/*	showSearch*/}
          {/*	className="w-full"*/}
          {/*	placeholder="Select Portfolio"*/}
          {/*	optionFilterProp="label"*/}
          {/*	onChange={(e) => {*/}
          {/*		setPortfolioId(e);*/}
          {/*	}}*/}
          {/*	options={portfolioList}*/}
          {/*/>*/}
          <Button
            disabled={rows.length === 0}
            onClick={() => {
              handlePostPortfolioData({
                // portfolioId,
                data: rows2TableData(rows),
              });
            }}
            className="mt-3"
          >
            Upload
          </Button>
          {/*</div>*/}
        </div>
      </div>
      <div className="flex flex-column h-full">
        <h3 className="w-full">Data preview {fileName}</h3>
        {loading && <ProgressSpinner />}
        {!loading && (
          <TableAgGeneric
            loading={loading}
            rows={tableRows}
            // rows={tableRows}
          />
        )}
      </div>
    </div>
  );
}
